var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1435_4452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7149 3.08042L11.1374 2.50268C10.9372 2.31276 10.7035 2.21777 10.4366 2.21777C10.1643 2.21777 9.93333 2.31276 9.74333 2.50268L6.00001 6.24609L2.25673 2.50279C2.06676 2.31287 1.83572 2.21788 1.56349 2.21788C1.29653 2.21788 1.06282 2.31287 0.862652 2.50279L0.292676 3.08053C0.0975228 3.27555 0 3.50925 0 3.78143C0 4.05867 0.0976307 4.28973 0.292649 4.47455L5.30675 9.48868C5.49168 9.68372 5.72263 9.78132 5.99999 9.78132C6.27213 9.78132 6.50581 9.68375 6.70078 9.48868L11.7149 4.47455C11.9049 4.28453 12 4.05349 12 3.78143C12 3.51433 11.9049 3.28076 11.7149 3.08042Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1435_4452"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.44aeed7fd80cafb4277be1b726d64e73.svg";
export { ForwardRef as ReactComponent };